import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { ProgramTitleWidget } from 'htv-lib'
import { Subscription } from 'rxjs'
import { LocalChannel } from '../../interfaces/local-channel'
import { LocalEPGProgram } from '../../interfaces/local-epg'
import { EpgService } from '../../services/epg.service'
import { PageService } from '../../services/page.service'
import moment from 'moment'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-program-title',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './program-title.component.html',
  styleUrls: [],
})
export class ProgramTitleComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: ProgramTitleWidget

  locale = moment.locale()
  text = ''

  constructor(
    private epgService: EpgService,
    private pageService: PageService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_PROGRAM)?.subscribe((program: LocalEPGProgram | undefined) => {
        if (program) {
          if (program.translations[this.locale]) {
            const translation = program.translations[this.locale]
            this.text = translation?.title ?? ''
          } else {
            const translation = program.translations[program.defaultTranslationCode]
            this.text = translation?.title ?? ''
          }
        } else {
          this.text = ''
        }
      })
    )

    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_CHANNEL)?.subscribe((channel: LocalChannel | undefined) => {
        if (channel) {
          const liveEPG = this.epgService.getChannelLiveEPG(channel.id)
          this.text = liveEPG?.currentProgram?.title ?? ''
        } else {
          this.text = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
